import React from 'react';

import SnowFlakeSvg from './assets/snowflake.svg';

export const Snowflake = () => (
  <div>
    <img src={SnowFlakeSvg} alt="SVG Icon" title="snowflake" />
  </div>
);
